<div class="user-menu">
  <div class="user-menu__mobile">
    <a [routerLink]="['/resources/personnel', userId]">{{userName}} {{userSurname}}</a>
    <a [routerLink]="['/resources/organization', orgId]">{{userOrg}}</a>
  </div>
  <div class="user-menu__desktop" #menuContainerRef>
    <button class="user-menu__trigger" (click)="toggleDropdown($event)" (keydown.enter)="toggleDropdown($event)"
      (keydown.space)="toggleDropdown($event)" [class.user-menu__trigger--active]="isDropdownOpen"
      [attr.aria-expanded]="isDropdownOpen" [attr.aria-haspopup]="true"
      [attr.aria-label]="translateData?.user_menu || 'User menu'">
      <img class="header__icon header__icon--user icon-header" src="assets/icons/header/user_profile.svg"
        alt="User">

        <!-- Tooltip -->
        @if (!isDropdownOpen) {
          <span class="user-menu__tooltip">
            {{ translateData?.user || 'User' }}
          </span>
        }
      </button>

      <!-- Dropdown -->
      <div class="user-menu__dropdown" [class.user-menu__dropdown--open]="isDropdownOpen" #dropdownRef role="menu"
        [attr.aria-hidden]="!isDropdownOpen">

        <!-- Header with user info -->
        <div class="user-menu__header">
          <div class="user-menu__user-info">
            <button class="user-menu__avatar" (click)="openImagePreview($event)"
              (keydown.enter)="openImagePreview($event)" (keydown.space)="openImagePreview($event)"
              [class.user-menu__avatar--clickable]="userAvatar" [disabled]="!userAvatar"
              [attr.aria-label]="(translateData?.view_profile_picture || 'View profile picture') + ': ' + userName + ' ' + userSurname"
              type="button">
              <img [src]="userAvatar || 'assets/icons/default-avatar.svg'" [alt]="userName"
                (error)="userAvatar = ''">
                <!-- Magnifying glass icon overlay -->
                @if (userAvatar) {
                  <div class="user-menu__avatar-overlay" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2">
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="m21 21-4.35-4.35"></path>
                    </svg>
                  </div>
                }
              </button>
              <div class="user-menu__user-details">
                <div class="user-menu__user-name">{{ userName || 'User' }} {{ userSurname || '' }}</div>
                <div class="user-menu__user-org">{{ userOrg || 'Organizartion' }}</div>
              </div>
            </div>
          </div>

          <!-- Menu items -->
          <div class="user-menu__list" role="none">
            <button class="user-menu__item" (click)="navigateToProfile()" (keydown.enter)="navigateToProfile()"
              (keydown.space)="navigateToProfile()" role="menuitem"
              [attr.aria-label]="translateData?.view_profile || 'View Profile'">
              <div class="user-menu__item-content">
                <div class="user-menu__item-title">
                  {{ translateData?.view_profile || 'View Profile' }}
                </div>
                <div class="user-menu__item-description">
                  {{ translateData?.manage_account || 'Manage your account settings' }}
                </div>
              </div>
              <div class="user-menu__item-arrow" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </button>

            <button class="user-menu__item" (click)="navigateToOrganization()"
              (keydown.enter)="navigateToOrganization()" (keydown.space)="navigateToOrganization()"
              role="menuitem" [attr.aria-label]="translateData?.settings || 'Settings'">
              <div class="user-menu__item-content">
                <div class="user-menu__item-title">
                  {{ translateData?.organization || 'Organization' }}
                </div>
                <div class="user-menu__item-description">
                  {{ translateData?.organization_settings || 'Manage your organization settings' }}
                </div>
              </div>
              <div class="user-menu__item-arrow" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </button>
          </div>
        </div>

        <!-- Backdrop -->
        @if (isDropdownOpen) {
          <div class="user-menu__backdrop" (click)="closeDropdown()"
          (keydown.escape)="closeDropdown()" tabindex="-1" aria-hidden="true"></div>
        }
      </div>

      <!-- Image Preview Modal -->
      @if (isImagePreviewOpen) {
        <div class="image-preview-modal" (click)="closeImagePreview()"
          (keydown.escape)="closeImagePreview()" role="dialog"
          [attr.aria-label]="(translateData?.profile_picture_preview || 'Profile picture preview') + ': ' + userName + ' ' + userSurname"
          aria-modal="true" tabindex="-1">
          <div class="image-preview-modal__backdrop" aria-hidden="true"></div>
          <div class="image-preview-modal__container">
            <!-- Close button -->
            <button class="image-preview-modal__close" (click)="closeImagePreview()"
              (keydown.enter)="closeImagePreview()" (keydown.space)="closeImagePreview()" type="button"
              [attr.aria-label]="translateData?.close || 'Close'">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <!-- Image container -->
            <div class="image-preview-modal__image-container" (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()" role="img" [attr.aria-label]="userName + ' profile picture'">
              <img [src]="userAvatar" [alt]="userName + ' profile picture'" class="image-preview-modal__image">
            </div>
            <!-- User info -->
            <div class="image-preview-modal__info" role="region"
              [attr.aria-label]="translateData?.user_information || 'User information'"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <h3 class="image-preview-modal__name">{{ userName }} {{ userSurname }}</h3>
              <p class="image-preview-modal__org">{{ userOrg }}</p>
            </div>
          </div>
        </div>
      }
    </div>